import { Vue, Component } from 'vue-property-decorator'
import { makeComputedBinding } from 'shared/util'
import { ConnectionStatus } from 'shared/types/ConnectionStatus'


@Component
export class ServerModule extends Vue {

	wsUrl = 'ws://localhost:443'
	hostname = 'localhost'
	state: ConnectionStatus = 'unconnected'
	ws: WebSocket | null = null
	packetListeners: Array<((channel: string, packet: any) => void) | undefined> = []

	setWsUrl(wsUrl) {
		if(!wsUrl) { return }
		try {
			const url = new URL(wsUrl)
			this.wsUrl = wsUrl
			this.hostname = url.hostname
		} catch(e) {
			console.error('Invalid websocket url received: ' + wsUrl)
		}
	}

	connect() {
		return new Promise((resolve, reject) => {
			this.state = 'unconnected'

			try {
				this.ws = new WebSocket(this.wsUrl)
			} catch(err) {
				return reject(err)
			}

			this.ws.addEventListener('open', () => {
				this.state = 'connected'
				resolve(1)
			})

			this.ws.addEventListener('close', () => {
				this.state = 'disconnected'
			})

			this.ws.addEventListener('message', msg => {

				let data
				try {
					data = JSON.parse(msg.data)
				} catch (e) {
					// A single malformed/truncated frame (e.g. a flaky mobile connection)
					// shouldn't crash the socket handler — drop it and wait for the next one.
					console.error('Failed to parse websocket message:', e)
					return
				}
				Object.keys(data).forEach(channel => {
					this.packetListeners
						.filter(listener => listener)
						.forEach(listener => listener!(channel, data[channel]))
				})
			})
		})
	}

	send(message: any) {
		if(!this.ws || this.ws.readyState !== this.ws.OPEN) { return }
		this.ws.send(JSON.stringify(message))
	}

	addListener(listener: (type: string, packet: any) => void): number {
		this.packetListeners.push(listener)
		return this.packetListeners.length - 1
	}

	removeListener(id: number) {
		this.packetListeners[id] = undefined
	}

}

export const Server = new ServerModule()
export const ServerState = makeComputedBinding(Server)
